<rd-widget-slide-out [widget]="widget">
  <div slide-out-template class="widget-period-over-period-slide-out gridster-item-content">
    <table aria-hidden="true" *ngIf="periods">
      <thead>
        <tr>
          <th scope="col" colspan="13">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="col" colspan="5">{{'periodOverPeriod.labelSlideoutPeriod' | rdTranslate}}</th>
          <th scope="col" colspan="5">{{'periodOverPeriod.labelSlideoutValuationDate' | rdTranslate}}</th>
          <th scope="col" colspan="1">{{'periodOverPeriod.labelSlideoutShow' | rdTranslate}}</th>
          <th scope="col" colspan="1">{{'periodOverPeriod.labelSlideoutPeriodX' | rdTranslate}}</th>
          <th scope="col" colspan="1">{{'periodOverPeriod.labelSlideoutPeriodY' | rdTranslate}}</th>
        </tr>

        <tr *ngFor="let period of periods; let i = index; trackBy:trackByPeriodFn">
          <td colspan="5">
            <input type="text" class="periodLabel" [(ngModel)]="period.label" />
          </td>
          <td colspan="5">
            <kendo-dropdownlist [data]="reports" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="period.reportId"
                                (valueChange)="onReportChanged()">
            </kendo-dropdownlist>
          </td>
          <td colspan="1">
            <input type="checkbox"
                   [(ngModel)]="period.visible"
                   (ngModelChange)="visibilityChanged(period)" />
          </td>
          <td colspan="1">
            <input type="radio"
                   name="periodX"
                   [value]="period.id"
                   [checked]="period.id === periodXId"
                   (change)="onRadioXSelect(period)" />
          </td>
          <td colspan="1">
            <input type="checkbox"
                   [(ngModel)]="period.isPeriodY"
                   (ngModelChange)="onPeriodYChanged(period)" />
          </td>
        </tr>

        <tr *ngIf="periods.length">
          <td colspan="5">{{'periodOverPeriod.labelSlideoutHideFootnote' | rdTranslate}}</td>
          <td colspan="8" class="align-left">
          <input type="checkbox"
                  [(ngModel)]="periods[0].hideFootnote"
                  (ngModelChange)="hideFootnoteChanged()" />
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</rd-widget-slide-out>
